<template>
  <div :style="{ width }" class="box fvlr">
    <van-icon v-if="icon" size="20px" :name="icon" />
    <div class="result ellipsis" :class="{ noVal: !result }">
      {{ result || placeHolder }}
    </div>
    <van-icon name="arrow-down" />
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'

export default {
  props: ['result', 'width', 'placeHolder', 'icon'],
  setup(props) {
    let { result, width, placeHolder } = toRefs(props)
    const state = reactive({
      count: 0,
      result,
      width,
      placeHolder
    })
    onMounted(() => {})
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  height: 40px;
  padding: 13px 12px;
  box-sizing: border-box;
  border: solid 1px #eeeeee;
  background-color: #ffffff;
}
.result {
  font-size: 14px;
  color: #333333;
  width: 100%;
  margin: 0 5px;
  text-align: left;
}
.noVal {
  color: #999999;
}
</style>
